import { EMPTY_OBJECT } from '../../../../constants/common'
import { Status } from '../../../Status'
import Text from '../../../Text'
import { useCalendarGridContext } from '../../CalendarGrid.hooks'
import {
  QA_NAME_CALENDAR_GRID_DAY_POPOVER_LOAD,
  QA_NAME_CALENDAR_GRID_DAY_POPOVER_SUMMARY,
} from '../CalendarGridDayPopover.constants'

function CalendarGridDayPopoverHeader({
  dayLoad: { loadLabel, summary, tag } = EMPTY_OBJECT,
  headerTagItem,
  isDayLoadView,
}) {
  const { ItemTag } = useCalendarGridContext()

  return isDayLoadView ? (
    <>
      <Status {...tag} />
      <Text isSecondary qaName={QA_NAME_CALENDAR_GRID_DAY_POPOVER_LOAD}>
        {loadLabel}
      </Text>
    </>
  ) : headerTagItem ? (
    <ItemTag item={headerTagItem} />
  ) : (
    <Text isSecondary qaName={QA_NAME_CALENDAR_GRID_DAY_POPOVER_SUMMARY}>
      {summary}
    </Text>
  )
}

export default CalendarGridDayPopoverHeader
